if (!customElements.get('discovery-popup')) {
    customElements.define('discovery-popup', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.initialized = false;
        // Editor replacements can connect the element before its children exist.
        this.observer = new MutationObserver(() => this.initialize());
        this.observer.observe(this, { childList: true, subtree: true });
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true, signal: this.controller.signal });
        } else {
          this.initialize();
        }
      }
      initialize() {
        if (this.initialized || !this.isConnected) return;
        this.dialog = this.querySelector('dialog');
        const closeButton = this.querySelector('[data-discovery-close]');
        const dismissButton = this.querySelector('[data-discovery-dismiss]');
        if (!this.dialog || !closeButton || !dismissButton) return;
        this.initialized = true;
        this.observer.disconnect();
        this.isEditor = this.dataset.editor === 'true' || Boolean(window.Shopify && window.Shopify.designMode);
        const campaign = this.dataset.campaign || '1';
        this.storageKey = 'parfumae:discovery-popup:dismissed' + (campaign === '1' ? '' : ':' + campaign);
        const options = { signal: this.controller.signal };
        closeButton.addEventListener('click', () => this.dialog.close(), options);
        dismissButton.addEventListener('click', () => {
          if (!this.isEditor) {
            try { localStorage.setItem(this.storageKey, 'true'); } catch (error) { /* Storage may be unavailable in private browsers. */ }
          }
          this.dialog.close();
        }, options);
        this.dialog.addEventListener('click', (event) => {
          const bounds = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => this.unlockScroll(), options);
        this.closest('.shopify-section')?.addEventListener('shopify:section:select', () => this.open(), options);
        this.closest('.shopify-section')?.addEventListener('shopify:section:deselect', () => this.dialog.close(), options);
        let dismissed = false;
        try { dismissed = localStorage.getItem(this.storageKey) === 'true'; } catch (error) { /* Keep the popup usable without storage. */ }
        if (!dismissed || this.isEditor) this.open();
      }
      open() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.scrollLocked = true;
      }
      unlockScroll() {
        if (!this.scrollLocked) return;
        document.documentElement.style.overflow = this.previousOverflow;
        this.scrollLocked = false;
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.dialog?.close();
        this.unlockScroll();
        this.controller.abort();
      }
    });
  }
